import React, {FC, useCallback, useState} from 'react';

import {UpsellConnected} from '../upsell/upsell';
import {getUpsells, UpsellType} from '../upsellsList/upsellsList';

export type CoverageUpsellType = {
    price: number;
    isAdded: boolean;
    toggleUpsell: () => void;
    copayPrice: number;
    phone: string;
    title: string;
    icon: string;
    itemId?: string;
};

/**
 * Hydrophobic Upsell for cart
 * @param {UpsellType} props - component props
 * @constructor
 */
export const Upsell: FC<UpsellType> = props => {
    const [isModalVisible, setVisibility] = useState(false);
    const commonProps = {...props, onClose: setVisibility};
    const {content, icon, name, needToShowPrice, popup, title, titleStylesForDescription} =
        getUpsells(commonProps);

    return (
        <UpsellConnected
            closeModal={useCallback(() => setVisibility(false), [])}
            icon={icon}
            isAdded={props.isAdded}
            isModalVisible={isModalVisible}
            itemId={props.itemId}
            name={name}
            needToShowPrice={needToShowPrice || false}
            openModal={useCallback(() => setVisibility(true), [])}
            popup={popup}
            price={props.price}
            specialPrice={props.specialPrice}
            // titleStylesForDescription prop needs because title should be a string instead of node
            // and sunglasses upsell has react element in title instead of string, but styles should be as for title
            title={title || ''}
            // instead of children
            titleStylesForDescription={titleStylesForDescription}
            toggleUpsell={props.toggleUpsell}
        >
            {content}
        </UpsellConnected>
    );
};
